export default __webpack_public_path__ + "static/media/title_pc@2x.2a3aed49.png";